<template>
    <div @click.prevent='gotodetail(data.id)' class="small-news-wrapper">
        <div class="img">
            <img :src="data.thumb" alt="">
        </div>
        <div class="bottom">
            <div class="name">{{ data.title }}</div>
            <div class="timer flex-start">
                <div class="tag" v-for="(child, childIndex) in data.tag" :key="childIndex">{{ child }}</div>
                {{ data.time }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {

        }
    },
    methods: {
        gotodetail(id) {
            this.$router.push('/newsDetail?id=' + id);
        }

    }
}
</script>
<style lang="scss" scoped>
.small-news-wrapper {
    width: 4rem;
    height: 3.12rem;
    background: #F5FAFA;
    cursor: pointer;
    position: relative;
    z-index: 90;

    .bottom {
        padding: 0.12rem;

        .name {
            height: 0.44rem;
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 600;
            font-size: 0.16rem;
            line-height: 0.22rem;
            color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            -webkit-box-orient: vertical;
        }

        .timer {
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 400;
            font-size: 0.12rem;
            line-height: 0.12rem;
            color: #000000;
            margin-top: 0.2rem;

            .tag {
                border: 1px solid #E02E43;
                border-radius: 0.04rem;
                padding: 0.04rem;
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.12rem;
                line-height: 0.12rem;
                color: #E02E43;
                margin-right: 0.12rem;
            }
        }
    }

    .img {
        width: 100%;
        height: 2rem;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
}

@media (max-width: 750px) {
    .small-news-wrapper img {
        height: 3.9rem;
    }

    .small-news-wrapper .img {
        height: 3.9rem;
    }

    .small-news-wrapper .bottom .name {
        font-size: 0.32rem;
        line-height: 0.4rem;
    }

    .small-news-wrapper .bottom {
        padding: 0.24rem;
    }

    .small-news-wrapper .bottom .timer .tag {
        padding: 0.1rem 0.06rem;
    }

    .small-news-wrapper {
        width: 100%;
        height: auto;
    }
}
</style>